export default [
  {
    path: 'assessment-requests',
    component: () => import('@/pages/garage/AssessmentRequests/Index.vue'),
    name: 'garage.assessment-requests',
    meta: {
      breadCrumb: 'Assessment Requests',
      title: 'Assessment Requests',
      requiresAuth: true,
    },
  },
  {
    path: 'assessment-requests/:id',
    component: () => import('@/pages/garage/AssessmentRequests/Show.vue'),
    name: 'garage.assessment-requests.show',
    props: true,
    meta: {
      breadCrumb: 'Assessment Request',
      title: 'Assessment Requests',
      requiresAuth: true,
    },
  },
]
